export default "__VITE_ASSET__BhPa9SaW__"